import {
    Box,
    Heading,
    SimpleGrid,
    Text,
    useColorModeValue,
    Flex,
    Input,
    IconButton,
    MenuList,
    Menu,
    MenuButton,
    MenuItem,
    Link,
    Checkbox,
    Tooltip,
    Icon,
} from "@chakra-ui/react";
import * as React from "react";
import { Button } from "@chakra-ui/button";
import { loadStripe, StripeCardElement } from "@stripe/stripe-js";
import { postData } from "../../utils/helpers";
import { firebaseClient } from "../../firebaseClient";
import { useSession } from "next-auth/react";
import toast from "react-hot-toast";
import { getAccount, updateUser } from "utils/sessionHelper";
import { ImCross } from "react-icons/im";
import { AiOutlineLock, AiOutlineShareAlt } from "react-icons/ai";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useFirebaseUser } from "utils/useFirebaseUser";
import { layerStyle, textStyle } from "theme/names";


export const Member = ({member, setMembers, setSelectedMember, onOpenRemove, isOwner, index}) => {

    const { data: session } = useSession() ?? {}
    const teamMemberBgColor = useColorModeValue("gray.50", "gray.700");
    const [isLoading, setIsLoading] = React.useState(false);

    return (
        <Flex
            layerStyle={layerStyle.bgBorderGrayRounded}
            // bg={teamMemberBgColor}
            p={2} pl={5} mt={2}
            // rounded="lg"
            key={index} justifyContent="space-between" alignItems="center"
        >
            <Text textStyle={textStyle["body.medium.light"]} w="250px" noOfLines={1} wordBreak={"break-all"} >{member.email}</Text>
            <Text textStyle={textStyle["body.medium.light"]} w="70px" color="gray.500"><i>{member.status}</i></Text>
            <Tooltip hasArrow label={member.orgAcceptShare ? "Account shared with content writers, admins and organization owner" : "The user chose to not share her/his account"}>
                <Flex alignItems="center">
                    <Icon ml={4} mr={2} color="gray.500" as={member.orgAcceptShare ? AiOutlineShareAlt : AiOutlineLock} />
                </Flex>
            </Tooltip>
            <Menu variant="secondary">
                <MenuButton
                    w="170px"
                    as={Button}
                    isDisabled={
                        member.id === session?.user?.data?.subscription?.org 
                        ||  (member.role === "Admin" && !isOwner)
                    }
                    // size="sm"
                    variant="secondary"
                    rightIcon={<ChevronDownIcon />}
                    marginX="2"
                    mt={{ base: "4", md: "0" }}
                    isLoading={isLoading}
                >
                    {session?.user?.data?.subscription?.org == member.id ? "Owner" : (member.role ?? "Member")}
                </MenuButton>
                <MenuList maxH="215px">
                    {/* {(isOwner ? ["Member", "Content Writer", "Admin"] : ["Member", "Content Writer"]).map((x) => ( */}
                    {["Member", "Content Writer", "Admin"].map((x) => (
                        <MenuItem
                            key={x}
                            onClick={async (e) => {
                                setIsLoading(true);
                                let result = await postData({
                                    url: "payment-changeRole", token: "",
                                    data: {
                                        role: x,
                                        email: member.email,
                                        org: session?.user?.data?.subscription?.org ?? session?.user?.uid, // fallback in case org just got created
                                    },
                                    session,
                                });
                                setIsLoading(false);
                                if (result.success) {
                                    setMembers(result.members);
                                }
                                else {
                                    toast.error("An error occurred: " + result.message);
                                }
                            }}
                        >
                            {x}
                        </MenuItem>
                    ))}
                </MenuList>
            </Menu>
            <IconButton
                // size="sm"
                variant="actionDestructive"
                aria-label="delete account"
                icon={<ImCross fontSize="8px" />}
                isDisabled={
                    member.id === session?.user?.data?.subscription?.org 
                    ||  (member.role === "Admin" && !isOwner)
                }
                onClick={async (e) => {
                    setSelectedMember(member);
                    onOpenRemove();
                }}
            />
        </Flex>
    );
};

export default Member;
